export default "__VITE_ASSET__Dp_dUidr__"